import PropTypes from "prop-types";
import MKTypography from "components/MKTypography";
import Divider from "@mui/material/Divider";
import MKBox from "components/MKBox";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import DeleteOutline from "@mui/icons-material/DeleteOutline";

const Details = ({ event, formatEventDates, canDelete, onDelete }) => (
  <MKBox p={2} className="entry-content">
    {/* Titre + actions */}
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <MKTypography variant="h3" sx={{ mr: 1 }}>
        {event.title}
      </MKTypography>

      {canDelete && typeof onDelete === "function" && (
        <Tooltip title="Supprimer l’évènement">
          <IconButton aria-label="Supprimer" color="error" onClick={onDelete}>
            <DeleteOutline />
          </IconButton>
        </Tooltip>
      )}
    </Box>

    <MKTypography variant="body1" color="textSecondary">
      {formatEventDates()}
    </MKTypography>

    <Divider sx={{ my: 3 }} />

    <MKTypography
      variant="body1"
      component="div"
      dangerouslySetInnerHTML={{ __html: event.description }}
    />

    <Divider sx={{ my: 3 }} />

    <MKTypography variant="h5" mt={2} mb={1}>
      Informations Complémentaires
    </MKTypography>
    <MKTypography variant="body2" color="textSecondary" mb={1}>
      <strong>Date(s) et heures :</strong> {formatEventDates()}
    </MKTypography>
    {event.locationManual && (
      <MKTypography variant="body2" color="textSecondary" mb={1}>
        <strong>Lieu :</strong> {event.locationManual}
      </MKTypography>
    )}
    {event.price !== undefined && (
      <MKTypography variant="body2" color="textSecondary" mb={1}>
        <strong>Prix :</strong> {event.price ? `${event.price}€` : "Gratuit"}
      </MKTypography>
    )}
    {event.organizerManual && (
      <MKTypography variant="body2" color="textSecondary" mb={1}>
        <strong>Organisateur :</strong> {event.organizerManual}
      </MKTypography>
    )}
    {event.url && (
      <MKTypography variant="body2" color="textSecondary" mb={1}>
        <strong>Site web :</strong>{" "}
        <a href={event.url} target="_blank" rel="noopener noreferrer">
          {event.url}
        </a>
      </MKTypography>
    )}
    {event.email && (
      <MKTypography variant="body2" color="textSecondary" mb={1}>
        <strong>Email :</strong> <a href={`mailto:${event.email}`}>{event.email}</a>
      </MKTypography>
    )}
  </MKBox>
);

Details.propTypes = {
  event: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    locationManual: PropTypes.string,
    price: PropTypes.number,
    organizerManual: PropTypes.string,
    url: PropTypes.string,
    email: PropTypes.string,
  }).isRequired,
  formatEventDates: PropTypes.func.isRequired,
  canDelete: PropTypes.bool,
  onDelete: PropTypes.func,
};

export default Details;
